import { Nav } from "@/components/site/Nav";
import { Seo } from "@/components/Seo";
import { Link } from "react-router-dom";

const OWNER = "[Til eier: fyll inn juridisk navn, org.nr og adresse]";

function Section({ title, children }) {
  return (
    <section className="mt-10">
      <h2 className="font-serif text-2xl text-olive-deep">{title}</h2>
      <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-olive/80">{children}</div>
    </section>
  );
}

export default function Terms() {
  return (
    <div className="min-h-screen bg-cream text-olive-deep">
      <Seo title="Kjøpsvilkår – Helserebellen" description="Vilkår for kjøp av digitale planer hos Helserebellen: pris, levering, angrerett for digitalt innhold og support." path="/vilkar" />
      <Nav />
      <main className="mx-auto max-w-3xl px-5 md:px-8 pt-28 pb-24">
        <p className="font-script text-4xl text-terra">Vilkår</p>
        <h1 className="mt-2 font-serif text-4xl md:text-5xl">Kjøpsvilkår</h1>
        <p className="mt-4 text-[15px] text-olive/70">Selger: {OWNER}. Kontakt: <a href="mailto:kontakt@helserebellen.no" className="underline text-terra">kontakt@helserebellen.no</a>.</p>

        <Section title="1. Produkt og pris">
          <p>Vi selger digitale planer (PDF) i norske kroner (NOK). Prisen som vises er endelig – det legges ikke til MVA. Detoxplan kr 399, Livsstilsplan kr 299, Booty &amp; Hourglass kr 499.</p>
        </Section>

        <Section title="2. Betaling">
          <p>Betaling skjer via Stripe-hostet checkout. Kortopplysninger håndteres av Stripe og lagres aldri hos oss.</p>
        </Section>

        <Section title="3. Levering">
          <p>Etter bekreftet betaling får du planen umiddelbart – både på skjermen og via en sikker, tidsbegrenset nedlastingslenke på e-post. Lenken er gyldig i 30 dager og kan reutstedes ved behov (kontakt oss).</p>
        </Section>

        <Section title="4. Angrerett for digitalt innhold">
          <p>For digitalt innhold som leveres umiddelbart, samtykker du ved kjøp til at leveringen starter med en gang, og at angreretten dermed bortfaller når nedlastingen er startet, jf. angrerettloven.</p>
        </Section>

        <Section title="5. Refusjon og reklamasjon">
          <p>Opplever du feil med produktet, ta kontakt så finner vi en løsning. Refusjoner håndteres via Stripe.</p>
        </Section>

        <Section title="6. Ansvar / helsefaglig forbehold">
          <p>Innholdet er generell informasjon og erstatter ikke individuell medisinsk rådgivning. Rådfør deg med lege ved sykdom, graviditet eller bruk av medisiner.</p>
        </Section>

        <div className="mt-12 border-t border-olive/12 pt-6 text-[14px]">
          <Link to="/" className="underline text-terra hover:text-olive-deep">← Til forsiden</Link>
          <span className="mx-3 text-olive/30">·</span>
          <Link to="/personvern" className="underline text-terra hover:text-olive-deep">Personvern</Link>
        </div>
      </main>
    </div>
  );
}
